import { Component, OnInit, Renderer2, Input, HostListener } from '@angular/core';
import { INCPCCPayment } from 'epay-library';
import { EpayExtendedServiceService } from 'src/app/helpers/services/epay-extended-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'iframe-fort-point',
  templateUrl: './iframe-fort-point.component.html',
  styleUrls: ['./iframe-fort-point.component.css'],
})
export class ExternalIframeComponent implements OnInit {
  @Input() creditCardPayment: INCPCCPayment = {} as INCPCCPayment;

  private _transactionId = '';
  private scriptAlreadyLoaded = false;

  @Input()
  set transactionId(value: string) {
    this._transactionId = value;
  }

  get transactionId(): string {
    return this._transactionId;
  }

  constructor(
    private renderer: Renderer2,
    private paymentService: EpayExtendedServiceService,
    private router: Router
  ) {}

  paymentDetails: any = {};

  ngOnInit(): void {
    const state = history.state;
    if (state?.transactionId) {
      this.transactionId = state.transactionId;
    } else {
      console.warn('[iframe] No transactionId found in history state');
    }
  
    const storedPayment = sessionStorage.getItem('creditCardPayment');
    if (storedPayment) {
      this.creditCardPayment = JSON.parse(storedPayment);
    } else {
      console.warn('[iframe] No creditCardPayment found in sessionStorage');
    }
  
    if (
      this.transactionId &&
      this.creditCardPayment &&
      !isNaN(this.creditCardPayment.totalAmount)
    ) {
      this.loadPaymentGatewayScript();
    } else {
      console.warn('[iframe] Missing transactionId or totalAmount. Script not loaded.');
    }
  
    window.addEventListener("message", this.handlePaymentMessage);
  }

  handlePaymentMessage = (event: MessageEvent) => {
    console.log('Received postMessage:', event);
    const data = event.data;
    console.log('Parsed message data:', data);
  };

  loadPaymentGatewayScript(): void {
    if (this.scriptAlreadyLoaded) return;
    const totalAmount = this.creditCardPayment?.totalAmount;
    if (totalAmount === undefined || isNaN(totalAmount)) {
      console.warn('[iframe] Aborting script load: totalAmount is missing or invalid:', totalAmount);
      return;
    }

    this.scriptAlreadyLoaded = true;

    const paymentFormElement = document.getElementById('payment-form');
    if (!paymentFormElement) {
      console.error('Payment form element not found in the DOM.');
      return;
    }

    // const script = this.renderer.createElement('script');
    // script.type = 'text/javascript';
    // script.text = `
    //   (function() {
    //     const options = {
    //       data: "eyJkYmFJZCI6IjEwOSIsInRlcm1pbmFsSWQiOiI4MSIsInRocmVlZHMiOiJEaXNhYmxlZCIsInJldHVyblVybCI6Imh0dHBzOlwvXC9zbWFydHBheS1wcm94eS51YXQuc21hcnRjaGlsZHN1cHBvcnQuY29tXC9jcmVkaXRjYXJkPHN0YXR1cz4%2FZXh0ZXJuYWxJZD08ZXh0ZXJuYWxJZD4iLCJyZXR1cm5VcmxOYXZpZ2F0aW9uIjoidG9wIiwibG9nbyI6bnVsbCwidmlzaWJsZU5vdGUiOm51bGwsInJlcXVlc3RDb250YWN0SW5mbyI6IlllcyIsInJlcXVlc3RCaWxsaW5nSW5mbyI6IlllcyIsInJlcXVlc3RTaGlwcGluZ0luZm8iOm51bGwsInNlbmRSZWNlaXB0IjoiWWVzIiwib3JpZ2luIjoiV0VCIiwiaGFzaCI6IjZmMjMzMWVjZGE4ZTc1MTEwOTcxMDNmZDIzMjU2OWYwIiwiY29udGFjdEluZm8iOnsiY29udGFjdE5hbWUiOiIiLCJjb250YWN0RW1haWwiOiIiLCJjb250YWN0UGhvbmUiOiIifSwiYmlsbGluZ0luZm8iOnsiYmlsbGluZ0NvdW50cnkiOm51bGwsImJpbGxpbmdTdHJlZXQiOiIiLCJiaWxsaW5nU3RyZWV0MiI6IiIsImJpbGxpbmdDaXR5IjoiIiwiYmlsbGluZ1N0YXRlIjpudWxsLCJiaWxsaW5nWmlwIjoiIn19",
    //       feeType: "amount",
    //       contactInfo: { name: "", email: "", phone: "" },
    //       billingInfo: {
    //         country: "United States",
    //         street: "",
    //         street2: "",
    //         city: "",
    //         state: "",
    //         zip: ""
    //       },
    //       dbaId: 109,
    //       terminalId: 81,
    //       threeds: 'Disabled',
    //       hash: '6f2331ecda8e7511097103fd232569f0',
    //       externalId: '${this.transactionId}',
    //       amount: '${this.creditCardPayment.totalAmount}',
    //       fee: '',
    //       returnURL: '',
    //       returnUrlNavigation: 'top',
    //       visibleNote: 'No',
    //       requestContactInfo: 'Yes',
    //       requestBillingInfo: 'Yes',
    //       sendReceipt: 'Yes',
    //       origin: 'WEB'
    //     };

    //     const initializePaymentGateway = function() {
    //       if (typeof PaymentGateway === 'undefined') {
    //         console.error('PaymentGateway is undefined.');
    //         return;
    //       }

    //       new PaymentGateway({
    //         target: "payment-form",
    //         options: options
    //       });

    //       window.paymentGatewayInitialized = true;
    //     };

    //     if (typeof window.PaymentGateway === "undefined") {
    //       window.paymentGatewayInitialized = false;
    //       window.webroot = "https://sandbox-smi.fppdashboard.com";
    //       const e = document.createElement("script");
    //       e.async = true;
    //       e.src = window.webroot + "/js/gateway/payment.js?v=" + Date.now();
    //       document.head.appendChild(e);
    //       e.onload = initializePaymentGateway;
    //     } else {
    //       window.paymentGatewayInitialized = false;
    //       initializePaymentGateway();
    //     }
    //   })();
    // `;

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function() {
        const options = {
          data: "eyJkYmFJZCI6IjIyMTM1MCIsInRlcm1pbmFsSWQiOiI0ODE1MTAiLCJ0aHJlZWRzIjoiRGlzYWJsZWQiLCJyZXR1cm5VcmwiOiJodHRwczpcL1wvcGF5bWVudHMuc21hcnRjaGlsZHN1cHBvcnQuY29tXC90cmliYWxcL2NyZWRpdGNhcmQ8c3RhdHVzPj9leHRlcm5hbElkPTxleHRlcm5hbElkPiIsInJldHVyblVybE5hdmlnYXRpb24iOiJ0b3AiLCJsb2dvIjpudWxsLCJ2aXNpYmxlTm90ZSI6bnVsbCwicmVxdWVzdENvbnRhY3RJbmZvIjoiWWVzIiwicmVxdWVzdEJpbGxpbmdJbmZvIjoiWWVzIiwicmVxdWVzdFNoaXBwaW5nSW5mbyI6bnVsbCwic2VuZFJlY2VpcHQiOiJZZXMiLCJvcmlnaW4iOiJXRUIiLCJoYXNoIjoiNTViN2RhMjcxM2E3NjNhM2I1Y2FmY2ExMjQ0Njc4ZjUiLCJjb250YWN0SW5mbyI6eyJjb250YWN0TmFtZSI6IiIsImNvbnRhY3RFbWFpbCI6IiIsImNvbnRhY3RQaG9uZSI6IiJ9LCJiaWxsaW5nSW5mbyI6eyJiaWxsaW5nQ291bnRyeSI6bnVsbCwiYmlsbGluZ1N0cmVldCI6IiIsImJpbGxpbmdTdHJlZXQyIjoiIiwiYmlsbGluZ0NpdHkiOiIiLCJiaWxsaW5nU3RhdGUiOm51bGwsImJpbGxpbmdaaXAiOiIifX0%3D",
          feeType: "amount",
          contactInfo: { name: "", email: "", phone: "" },
          billingInfo: {
            country: "United States",
            street: "",
            street2: "",
            city: "",
            state: "",
            zip: ""
          },
          dbaId: 221350,
          terminalId: 481510,
          threeds: 'Disabled',
          hash: '55b7da2713a763a3b5cafca1244678f5',
          externalId: '${this.transactionId}',
          amount: '${this.creditCardPayment.totalAmount}',
          fee: '',
          returnURL: '',
          returnUrlNavigation: 'top',
          visibleNote: 'No',
          requestContactInfo: 'Yes',
          requestBillingInfo: 'Yes',
          sendReceipt: 'Yes',
          origin: 'WEB'
        };

        const initializePaymentGateway = function() {
          if (typeof PaymentGateway === 'undefined') {
            console.error('PaymentGateway is undefined.');
            return;
          }

          new PaymentGateway({
            target: "payment-form",
            options: options
          });

          window.paymentGatewayInitialized = true;
        };

        if (typeof window.PaymentGateway === "undefined") {
          window.paymentGatewayInitialized = false;
          window.webroot = "https://fppdashboard.com";
          const e = document.createElement("script");
          e.async = true;
          e.src = window.webroot + "/js/gateway/payment.js?v=" + Date.now();
          document.head.appendChild(e);
          e.onload = initializePaymentGateway;
        } else {
          window.paymentGatewayInitialized = false;
          initializePaymentGateway();
        }
      })();
    `;

    this.renderer.appendChild(document.body, script);

    // Add accessibility attributes to dynamically created iframe for ADA compliance
    setTimeout(() => {
      this.addIframeAccessibilityAttributes();
    }, 1000);
  }

  /**
   * Adds accessibility attributes to dynamically created payment iframe
   * for WCAG AA compliance
   */
  private addIframeAccessibilityAttributes(): void {
    try {
      const iframe = document.querySelector('iframe');
      if (iframe) {
        iframe.setAttribute('title', 'Credit Card Payment Form');
        iframe.setAttribute('aria-label', 'Credit Card Payment Form - Enter your payment information');
        console.log('Iframe accessibility attributes added successfully');
      } else {
        console.warn('Payment iframe not found for accessibility enhancement');
      }
    } catch (error) {
      console.warn('Failed to add iframe accessibility attributes:', error);
    }
  }
}
